<template>
  <div>
    <template v-if="$store.state.parcel.freeSmallWeightAddrMap[jyAddrid] === 3">
      計費重量小於等於0.05kg的輕小件全部不計重，每筆訂單最多可以贈送3個免重包裹位置。<br>
      <br>
    </template>
    <template v-else>
      計費重量小於等於0.05kg的輕小件全部不計重<br>
      <br>
    </template>
    <div>
      免重包裹說明：<br>
      如果訂單只有免重包裹（結帳時等於0KG），只需要支付島內派件費（暫不支持離島），就可以直接0KG打包回台。
    </div>
  </div>
</template>
<script>
export default {
  props: {
    jyAddrid: String,
  }
}
</script>
